export enum Collections {
	skvllpvnkz_hideout = 'skvllpvnkz_hideout',
	skvllpvnkz_daycare = 'skvllpvnkz_daycare',
}
